import { render, staticRenderFns } from "./SuggestTherapistsYEMSQ.vue?vue&type=template&id=832000f4&scoped=true&"
import script from "./SuggestTherapistsYEMSQ.vue?vue&type=script&lang=js&"
export * from "./SuggestTherapistsYEMSQ.vue?vue&type=script&lang=js&"
import style0 from "./SuggestTherapistsYEMSQ.vue?vue&type=style&index=0&id=832000f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832000f4",
  null
  
)

export default component.exports